export default "__VITE_ASSET__Kt3Q4Uem__"